import { useState, useEffect } from 'react';
import { fetchCategoryById, ApiCategory } from '../services/api';

export const useCategoryById = (id: number | null) => {
  const [category, setCategory] = useState<ApiCategory | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (id === null) {
      setCategory(null);
      return;
    }

    const loadCategory = async () => {
      try {
        setLoading(true);
        setError(null);
        const categoryData = await fetchCategoryById(id);
        setCategory(categoryData);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to load category';
        setError(errorMessage);
        console.error('Error loading category:', err);
      } finally {
        setLoading(false);
      }
    };

    loadCategory();
  }, [id]);

  return { category, loading, error };
};
